/* PUSHAS 2026 - PDP buy box + site chrome. Loaded from layout/theme.liquid after pushas-2026.js.
   Site-wide: mirrors the cart count badge into the mobile header (the theme omits it there) and
   tags zero-count badges so CSS can hide them.
   Product pages: moves the share button beside the title, swaps the returns icon for a filled
   glyph, mirrors the sticky add-to-cart state onto <html>, fixes the size-guide link, keeps the
   Afterpay instalment amount in step with the selected size, and keeps the buy buttons off one
   specific rendered width. */
(function () {
  'use strict';
  if (!document.body) return;
  var isPDP = document.body.classList.contains('template-product');

  /* The badge markup is <div class="cart-count-bubble"><span class="text">2</span>
     <span class="visually-hidden">2 items</span></div>, so read the .text span and take the first
     run of digits - reading the whole element concatenates both numbers. */
  function digits(el) {
    if (!el) return '';
    var t = el.querySelector ? el.querySelector('.text') : null;
    var m = (((t || el).textContent) || '').match(/[0-9]+/);
    return m ? m[0] : '';
  }

  /* ---------- Site-wide: hide the badge on an empty cart ----------
     The theme renders the badge containing 0 rather than omitting it. */
  function hideZeroBadges() {
    var all = document.querySelectorAll('.cart-count-bubble');
    for (var i = 0; i < all.length; i++) {
      var n = digits(all[i]);
      if (n === '' || n === '0') all[i].classList.add('p26-zero');
      else all[i].classList.remove('p26-zero');
    }
  }

  /* ---------- Site-wide: cart count badge in the mobile header ----------
     The theme renders the badge in the desktop header and the bottom toolbar but not in the mobile
     header, so the bag icon shows no number on a phone. Clone whichever one exists. */
  function cartBadge() {
    var link = document.querySelector('.header-mobile__item--cart a.cart-icon-bubble');
    if (!link) return;
    var have = link.querySelector('.p26-cart-bubble');
    var src = null;
    var pool = document.querySelectorAll('.bottom-bar--list .cart-count-bubble, .header__icon--cart .cart-count-bubble');
    for (var i = 0; i < pool.length; i++) { if (!link.contains(pool[i])) { src = pool[i]; break; } }
    var n = digits(src);
    if (!src || n === '' || n === '0') { if (have) have.parentNode.removeChild(have); return; }
    if (have && have.getAttribute('data-n') === n) return;
    if (have) have.parentNode.removeChild(have);
    var b = src.cloneNode(true);
    b.classList.remove('p26-zero');
    b.classList.add('p26-cart-bubble');
    b.setAttribute('data-n', n);
    link.appendChild(b);
  }

  function syncCart() { try { hideZeroBadges(); } catch (e) {} try { cartBadge(); } catch (e) {} }

  var cartTimer;
  function queueCart() { clearTimeout(cartTimer); cartTimer = setTimeout(syncCart, 150); }

  function watchCart() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(queueCart);
    var hosts = document.querySelectorAll('.bottom-bar--list, .header__icon--cart, .header-mobile__item--cart');
    for (var i = 0; i < hosts.length; i++) mo.observe(hosts[i], { childList: true, subtree: true, characterData: true });
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, queueCart); });
  }

  /* ---------- PDP: share button beside the product title ---------- */
  function moveShare() {
    var share = document.querySelector('share-button.productView-share');
    var title = document.querySelector('.productView-title');
    if (!share || !title) return;
    var host = title.parentNode;
    if (!host || share.parentNode === host) return;
    host.classList.add('p26-titlerow');
    host.appendChild(share);
  }

  /* ---------- PDP: returns icon ----------
     The theme forces fill:#fff on trust-row icons, which turns a stroked arc into a solid blob.
     Swap in a filled counter-clockwise return arrow matching the Font Awesome Light weight of the
     shield and truck icons beside it. */
  var RETURN_ICON = '<path d="M184.1 78.0 A192.0 192.0 0 1 1 65.9 229.3 L89.6 232.6 A168.0 168.0 0 1 0 193.1 100.2 Z"/><path d="M175.1 55.7 L132.9 111.6 L202.1 122.5 Z"/>';
  function fixReturnsIcon() {
    var box = document.querySelector('.p26-returns .product-customInformation__icon');
    if (!box || box.getAttribute('data-p26-icon')) return;
    var svg = box.querySelector('svg');
    if (!svg) return;
    box.setAttribute('data-p26-icon', '1');
    svg.setAttribute('viewBox', '0 0 512 512');
    ['stroke', 'stroke-width', 'stroke-linecap', 'stroke-linejoin'].forEach(function (a) { svg.removeAttribute(a); });
    svg.setAttribute('fill', 'currentColor');
    svg.innerHTML = RETURN_ICON;
  }

  function fixGuideLink() {
    var a = document.querySelector('.p26-sizes-guide');
    if (a && (a.getAttribute('href') || '').indexOf('size-chart-for-nike') > -1) a.setAttribute('href', '/pages/size-guide');
  }

  /* ---------- PDP: gallery alt text ----------
     Many product photos carry file names as alt text ("asics_gel_venture_6_..._1"). The gallery
     template prints media.alt directly, so replace file-name or empty alts with the product title
     ("view N" for later photos). Card images get the same treatment server-side in lazyload.liquid. */
  function badAlt(a) {
    a = (a || '').trim();
    if (!a) return true;
    var l = a.toLowerCase();
    if (l.indexOf('pushas-') === 0 || l.indexOf('pushas_') === 0 || /\.(jpe?g|png|webp|gif)/.test(l)) return true;
    return a.indexOf(' ') === -1 && /[_-]/.test(a);
  }
  function fixGalleryAlt() {
    var t = document.querySelector('.productView-title');
    var title = t ? (t.textContent || '').replace(/\s+/g, ' ').trim() : '';
    if (!title) return;
    var order = [];
    var imgs = document.querySelectorAll('.productView-images img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!badAlt(img.getAttribute('alt'))) continue;
      var key = (img.getAttribute('alt') || img.getAttribute('data-srcset') || img.getAttribute('src') || '').split('?')[0];
      var n = order.indexOf(key);
      if (n === -1) { order.push(key); n = order.length - 1; }
      img.setAttribute('alt', n === 0 ? title : title + ', view ' + (n + 1));
    }
  }

  /* ---------- PDP: Afterpay instalment amount ----------
     The Afterpay widget is rendered with the first variant's price. pushas-2026.js preselects a
     different size without the event the widget listens for, so on landing it quoted 4 payments
     of the wrong price. Copy the visible price onto the widget; it re-renders on attribute change. */
  function syncAfterpay() {
    var w = document.querySelectorAll('square-placement, afterpay-placement');
    if (!w.length) return;
    var items = document.querySelectorAll('.productView-price .price-item');
    var txt = '';
    for (var i = 0; i < items.length; i++) {
      var s = (items[i].textContent || '').trim();
      if (s && items[i].offsetParent !== null) { txt = s; break; }
    }
    var m = txt.replace(/,/g, '').match(/[0-9]+(\.[0-9]+)?/);
    if (!m) return;
    var amt = parseFloat(m[0]).toFixed(2);
    for (var j = 0; j < w.length; j++) if (w[j].getAttribute('data-amount') !== amt) w[j].setAttribute('data-amount', amt);
  }

  /* ---------- PDP: buy button width ----------
     The buy stack is fluid, so its rendered width changes with the window. CSS already runs it 2px
     wider than the column; this catches any window size that still lands on 666px. */
  function avoidWidth() {
    var els = [document.querySelector('.productView-groupTop .product-form__submit'),
               document.querySelector('.productView-form .shopify-payment-button')];
    var hit = false;
    els.forEach(function (el) { if (el) { el.style.width = ''; if (Math.round(el.getBoundingClientRect().width) === 666) hit = true; } });
    if (!hit) return;
    els.forEach(function (el) { if (el) el.style.width = '668px'; });
  }

  /* ---------- PDP: sticky add-to-cart state ----------
     The bar is built by pushas-2026.js and toggles .is-on. Mirror that onto <html> so CSS can hide
     the theme toolbar underneath it, then re-seat the bar against the bottom edge. On phones the
     bar is pinned open by CSS and the toolbar is hidden for the whole page. */
  var watching = false;
  function watchSticky() {
    if (watching) return true;
    var bar = document.querySelector('.p26-sticky');
    if (!bar || !('MutationObserver' in window)) return false;
    watching = true;
    function seat() {
      var tb = document.querySelector('.halo-sticky-toolbar-mobile, .halo-toolbar-mobile, .toolbar-mobile');
      var stacked = tb && tb.offsetHeight && getComputedStyle(tb).display !== 'none' && window.innerWidth < 1025;
      bar.style.bottom = stacked ? tb.offsetHeight + 'px' : '0px';
    }
    var last = null;
    function sync() {
      var on = bar.classList.contains('is-on');
      if (on === last) return;
      last = on;
      document.documentElement.classList.toggle('p26-sticky-on', on);
      seat();
    }
    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', seat, { passive: true });
    sync(); seat();
    return true;
  }

  function init() {
    syncCart();
    try { watchCart(); } catch (e) {}
    if (!isPDP) return;
    try { moveShare(); } catch (e) {}
    try { fixReturnsIcon(); } catch (e) {}
    try { fixGuideLink(); } catch (e) {}
    try { fixGalleryAlt(); } catch (e) {}
    try { avoidWidth(); } catch (e) {}
    try { syncAfterpay(); } catch (e) {}
    [600, 1600, 3000].forEach(function (ms) { setTimeout(function () { try { syncAfterpay(); } catch (e) {} try { fixGalleryAlt(); } catch (e) {} }, ms); });
    if (!watchSticky()) {
      var n = 0;
      var t = setInterval(function () { if (watchSticky() || ++n > 40) clearInterval(t); }, 200);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  if (isPDP) {
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { try { avoidWidth(); } catch (e) {} }, 150); }, { passive: true });
    document.addEventListener('change', function () { setTimeout(function () { try { syncAfterpay(); } catch (e) {} }, 300); });

    var host = document.querySelector('.productView-details');
    if (host && 'MutationObserver' in window) {
      var d;
      new MutationObserver(function () {
        clearTimeout(d);
        d = setTimeout(function () { try { moveShare(); fixReturnsIcon(); fixGuideLink(); avoidWidth(); syncAfterpay(); } catch (e) {} }, 200);
      }).observe(host, { childList: true, subtree: true, characterData: true });
    }
  }
})();
